<template>
  <span class="text-2xl">
    <sapn class="text-gray-500 logo-font lg:inline animate__bounceIn"
      >Strat<span
        class="font-bold text-primary animate__delay-1s animate__bounceInLeft"
        >O</span
      >Change</sapn
    >
    <span class="hidden logo-font animate__bounceIn"
      ><span
        class="font-bold text-primary animate__delay-1s animate__bounceInLeft"
        >O</span
      ></span
    >
  </span>
</template>

<script>
export default {
  name: "Logo"
};
</script>
